import { AsideMenuTopBar } from '@single-platform/components';
import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import {
  LinkPopupContentContainer,
  LinkPopupHeaderStyles
} from '@applicationKYC/LegalEntityQuestionnaire/components/linkPopup/linkPopup.style';

export const naceInfoLinks = {
  eurostat: 'https://ec.europa.eu/eurostat/web/nace/correspondence-tables',
  lithuania: 'https://www.registrucentras.lt/jar/fa/klasif/v_rusys.php?kla_nr=1',
  finland: 'https://stat.fi/en/luokitukset/corrmaps/toimiala_1_20080101%23toimiala_1_20250101',
  netherlands:
    'https://www.cbs.nl/en-gb/our-services/methods/classifications/activiteiten/standard-industrial-classifications'
};

export const LinkPopupNaceCodes = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <>
      <LinkPopupHeaderStyles>
        <AsideMenuTopBar handleClose={onClose} />
        <div>{t('nace_code_information_header')}</div>
      </LinkPopupHeaderStyles>
      <LinkPopupContentContainer>
        <Trans
          i18nKey="nace_info_rich"
          components={{
            0: <p />,
            1: <strong />,
            2: <p />,
            3: <p />,
            4: <h4 />,
            5: <a href={naceInfoLinks.eurostat} target="_blank" rel="noopener noreferrer" />,
            6: <p />,
            7: <a href={naceInfoLinks.lithuania} target="_blank" rel="noopener noreferrer" />,
            8: <p />,
            9: <a href={naceInfoLinks.finland} target="_blank" rel="noopener noreferrer" />,
            10: <p />,
            11: <a href={naceInfoLinks.netherlands} target="_blank" rel="noopener noreferrer" />
          }}
        />
      </LinkPopupContentContainer>
    </>
  );
};
